import { recordPath, recordRoute } from '@/shared/registry'

/** Where the class custom field pages live. */
export const classCustomFieldsPath = '/classes/class-custom-fields'
export const createClassCustomFieldPath = `${classCustomFieldsPath}/new`
export const classCustomFieldRoute = recordRoute('classes', 'class-custom-fields')
export const editClassCustomFieldRoute = `${classCustomFieldRoute}/edit`

/** A class custom field's details page. */
export function classCustomFieldPath(id: string): string {
  return recordPath('classes', 'class-custom-fields', id)
}

/** A class custom field's edit page. */
export function editClassCustomFieldPath(id: string): string {
  return `${classCustomFieldPath(id)}/edit`
}

/** The base of Class Custom Field Details' slots (`detailsSlots`). */
export const classCustomFieldDetailsSlot = 'classes.class-custom-field-details'

/** The API's class custom field endpoints: a GET finds them, a POST creates one. */
export const classCustomFieldsApi = '/classes/v1/class-custom-fields'

export function classCustomFieldApi(id: string): string {
  return `${classCustomFieldsApi}/${encodeURIComponent(id)}`
}

/** The enabled fields a new class of the organization has that the viewer fills in, as Create Class shows them. */
export function availableClassCustomFieldsApi(organizationId: string): string {
  return `${classCustomFieldsApi}/available/${encodeURIComponent(organizationId)}`
}

/** A class's custom fields and values: GET reads them, PUT replaces the values at the class's version. */
export function classCustomFieldValuesApi(classId: string): string {
  return `/classes/v1/classes/${encodeURIComponent(classId)}/custom-fields`
}

/** What each definition action needs, by the field's owner organization; a class's values go with the class. */
export const readClassCustomFieldsPermission = 'classes.class-custom-fields.read'
export const writeClassCustomFieldsPermission = 'classes.class-custom-fields.write'
